export default __webpack_public_path__ + "static/montserrat-v15-latin-800italic-67b6a6fe9b163d82f82afea049a4884d.ttf";